export const fontMap = {
    opal: {
        alfaSlabOne: {
            primary: 'Alfa Slab One',
            secondary: 'Geist',
        },
        anton: {
            primary: 'Anton',
            secondary: 'Geist',
        },
        bbhHegarty: {
            primary: 'BBH Hegarty',
            secondary: 'Geist',
        },
        bebasNeue: {
            primary: 'Bebas Neue',
            secondary: 'Geist',
        },
        birthstone: {
            primary: 'Birthstone',
            secondary: 'Geist',
        },
        boogaloo: {
            primary: 'Boogaloo',
            secondary: 'Geist',
        },
        bricolageGrotesque: {
            primary: 'Bricolage Grotesque',
            secondary: 'Geist',
        },
        cabin: {
            primary: 'Cabin',
            secondary: 'Geist',
        },
        cardo: {
            primary: 'Cardo',
            secondary: 'Geist',
        },
        chango: {
            primary: 'Chango',
            secondary: 'Geist',
        },
        chic: {
            primary: 'Abril Fatface',
            secondary: 'Geist',
        },
        chicle: {
            primary: 'Chicle',
            secondary: 'Geist',
        },
        cinzel: {
            primary: 'Cinzel',
            secondary: 'Geist',
        },
        coiny: {
            primary: 'Coiny',
            secondary: 'Geist',
        },
        concertOne: {
            primary: 'Concert One',
            secondary: 'Geist',
        },
        condensed: {
            primary: 'Archivo Narrow',
            secondary: 'Geist',
        },
        crushed: {
            primary: 'Crushed',
            secondary: 'Geist',
        },
        dmSans: {
            primary: 'DM Sans',
            secondary: 'Geist',
        },
        elegant: {
            primary: 'Playfair Display',
            secondary: 'Geist',
        },
        geometric: {
            primary: 'Poppins',
            secondary: 'Geist',
        },
        gfsNeohellenic: {
            primary: 'GFS Neohellenic',
            secondary: 'Geist',
        },
        gloriaHallelujah: {
            primary: 'Gloria Hallelujah',
            secondary: 'Geist',
        },
        graduate: {
            primary: 'Graduate',
            secondary: 'Geist',
        },
        grenzeGotisch: {
            primary: 'Grenze Gotisch',
            secondary: 'Geist',
        },
        homemadeApple: {
            primary: 'Homemade Apple',
            secondary: 'Geist',
        },
        ibmPlexSans: {
            primary: 'IBM Plex Sans',
            secondary: 'Geist',
        },
        jura: {
            primary: 'Jura',
            secondary: 'Geist',
        },
        leagueGothic: {
            primary: 'League Gothic',
            secondary: 'Geist',
        },
        lemonada: {
            primary: 'Lemonada',
            secondary: 'Geist',
        },
        lobster: {
            primary: 'Lobster',
            secondary: 'Geist',
        },
        lobsterTwo: {
            primary: 'Lobster Two',
            secondary: 'Geist',
        },
        lora: {
            primary: 'Lora',
            secondary: 'Geist',
        },
        luxury: {
            primary: 'Noto Serif Display',
            secondary: 'Geist',
        },
        macondo: {
            primary: 'Macondo',
            secondary: 'Geist',
        },
        mali: {
            primary: 'Mali',
            secondary: 'Geist',
        },
        manrope: {
            primary: 'Manrope',
            secondary: 'Geist',
        },
        merienda: {
            primary: 'Merienda',
            secondary: 'Geist',
        },
        merriweather: {
            primary: 'Merriweather',
            secondary: 'Geist',
        },
        michroma: {
            primary: 'Michroma',
            secondary: 'Geist',
        },
        modern: {
            primary: 'Inter',
            secondary: 'Geist',
        },
        montserrat: {
            primary: 'Montserrat',
            secondary: 'Geist',
        },
        nunito: {
            primary: 'Nunito',
            secondary: 'Geist',
        },
        pacifico: {
            primary: 'Pacifico',
            secondary: 'Geist',
        },
        permanentMarker: {
            primary: 'Permanent Marker',
            secondary: 'Geist',
        },
        prata: {
            primary: 'Prata',
            secondary: 'Geist',
        },
        rajdhani: {
            primary: 'Rajdhani',
            secondary: 'Geist',
        },
        raleway: {
            primary: 'Raleway',
            secondary: 'Geist',
        },
        roboto: {
            primary: 'Roboto',
            secondary: 'Geist',
        },
        rockSalt: {
            primary: 'Rock Salt',
            secondary: 'Geist',
        },
        sanchez: {
            primary: 'Sanchez',
            secondary: 'Geist',
        },
        sansSerif: {
            primary: 'Geist',
            secondary: 'Geist',
        },
        serif: {
            primary: 'Source Serif 4',
            secondary: 'Geist',
        },
        shantellSans: {
            primary: 'Shantell Sans',
            secondary: 'Geist',
        },
        solway: {
            primary: 'Solway',
            secondary: 'Geist',
        },
        teko: {
            primary: 'Teko',
            secondary: 'Geist',
        },
        unbounded: {
            primary: 'Unbounded',
            secondary: 'Geist',
        },
        unifrakturmaguntia: {
            primary: 'UnifrakturMaguntia',
            secondary: 'Geist',
        },
        urban: {
            primary: 'Oswald',
            secondary: 'Geist',
        },
        viga: {
            primary: 'Viga',
            secondary: 'Geist',
        },
    },
};
//# sourceMappingURL=fonts.js.map